import { render, staticRenderFns } from "./BudoPopup.vue?vue&type=template&id=d73a77d6"
import script from "./BudoPopup.vue?vue&type=script&lang=js"
export * from "./BudoPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports